import { authenticatedDownload } from "@app/shared/AuthenticatedDownload";
import ServiceBase from "@app/shared/serviceBase";
import { SoftwareRelease, CreateOrUpdateSoftwareRelease, SoftwareReleaseClient } from "@app/software-releases/softwareRelease";

export default class SoftwareReleaseService extends ServiceBase {

  public async getAll(): Promise<SoftwareRelease[]> {
    return await this.makeGet<SoftwareRelease[]>('software-releases/');
  }

  public async getById(softwareReleaseId: number): Promise<SoftwareRelease> {
    return await this.makeGet<SoftwareRelease>(`software-releases/${softwareReleaseId}`);
  }

  public async create(createSoftwareRelease: CreateOrUpdateSoftwareRelease): Promise<SoftwareRelease> {
    return await this.makePost<SoftwareRelease>(`software-releases/`, createSoftwareRelease);
  }

  public async update(softwareReleaseId: number, updateSoftwareRelease: CreateOrUpdateSoftwareRelease): Promise<boolean> {
    return await this.makePatch<boolean>(`software-releases/${softwareReleaseId}`, updateSoftwareRelease);
  }

  public async delete(softwareReleaseId: number): Promise<boolean> {
    return await this.makeDelete<boolean>(`software-releases/${softwareReleaseId}`);
  }

  public async getUnallocatedReleases(): Promise<string[]> {
    return await this.makeGet<string[]>('software-releases/unallocated-releases');
  }

  public async release(softwareReleaseId: number): Promise<boolean> {
    return await this.makePatch<boolean>(`software-releases/${softwareReleaseId}/release`);
  }

  public async getEligibleClients(softwareReleaseId: number): Promise<SoftwareReleaseClient[]> {
    return await this.makeGet<SoftwareReleaseClient[]>(`software-releases/${softwareReleaseId}/clients`);
  }
  public async updateClientsByReleaseId(softwareReleaseId: number, clientIds: number[]): Promise<void> {
    return await this.makePut<void>(`software-releases/${softwareReleaseId}/clients`, clientIds);
  }

  public async getEmailListCsv(softwareReleaseId: number): Promise<void> {
    authenticatedDownload(`${window.apiEndpointV2_0}/software-releases/${softwareReleaseId}/email-csv`, null);
  }

}
